import { maxLength, SelectInput, TextInput, useTranslate } from 'react-admin';
import { Box } from '@mui/material';
import { useWatch } from 'react-hook-form';
import { couponChoices, operatorCouponChoices } from '@/components/global/options/selectOptions';
import PropTypes from 'prop-types';
import { breakpoints } from '@/themes/themeOverrides/Breakpoints';

export const CouponGroupInput = ({ subform }) => {
    const translate = useTranslate();
    const sourcePrefix = subform ? 'collectionPoint.' : '';
    const selectedCouponSource = useWatch({ name: `${sourcePrefix}couponSource` });
    const selectedOperator = useWatch({ name: `${sourcePrefix}operator` });
    const operatorId = selectedOperator?.toString().toLowerCase();
    let choices = [...couponChoices];

    if (operatorId) {
        const matchingOperatorOption = operatorCouponChoices.find(choice => choice.id === operatorId);
        if (matchingOperatorOption) {
            const alreadyExists = choices.some(choice => choice.id === matchingOperatorOption.id);
            if (!alreadyExists) {
                choices.push(matchingOperatorOption);
            }
        }
    }

    return (
        <>
            <SelectInput
                source={`${sourcePrefix}couponSource`}
                label={translate('resources.collectionPoint.fields.couponSource')}
                fullWidth
                choices={choices}
                emptyText={translate('common.all')}
            />
            {selectedCouponSource === 'comp' && (
                <Box
                    sx={{
                        display: 'flex',
                        mb: '2em',
                        gap: '12px',
                        [`@media (max-width: ${breakpoints.values.md}px)`]: {
                            flexDirection: 'column',
                            gap: '0px',
                            mb: '0px',
                        },
                    }}
                >
                    <Box flex={1}>
                        <TextInput
                            source={`${sourcePrefix}couponRvmLocationId`}
                            label={translate('resources.collectionPoint.fields.couponRvmLocationId')}
                            fullWidth
                            validate={[maxLength(100, translate('common.validation.maxLength', { count: 100 }))]}
                        />
                    </Box>
                    <Box flex={1}>
                        <TextInput
                            source={`${sourcePrefix}couponCompPin`}
                            label={translate('resources.collectionPoint.fields.couponCompPin')}
                            fullWidth
                            validate={[maxLength(100, translate('common.validation.maxLength', { count: 100 }))]}
                        />
                    </Box>
                </Box>
            )}
        </>
    );
};

CouponGroupInput.propTypes = {
    subform: PropTypes.bool,
};
